export default "__VITE_ASSET__wYBIHIEo__"